module.exports = __webpack_public_path__ + "img/cloud_upload.d41f3517.svg";